import { useState } from "react"
import { Link, useLocation } from "react-router-dom"
import {Menu, X, Diamond} from 'lucide-react'

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/lifeline-bling", label: "Lifeline Bling" },
  { to: "/fortnite-bling", label: "Fortnite" },
  { to: "/valorant-bling", label: "Valorant" },
  { to: "/blog", label: "Latest Bling" },
  { to: "/about", label: "About" },
]

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-yellow-900/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <Diamond className="w-7 h-7 text-yellow-500 group-hover:text-yellow-400 transition-colors" />
            <span
              className="text-xl sm:text-2xl font-bold tracking-wider gold-shimmer"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              BLINGSKINS
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-semibold tracking-wide uppercase transition-all duration-300 ${
                  location.pathname === link.to
                    ? "text-yellow-400 bg-yellow-500/10"
                    : "text-gray-400 hover:text-yellow-400 hover:bg-white/5"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button Desktop */}
          <a
            href="#featured-games"
            className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-lg gold-shimmer-bg text-black font-bold text-sm tracking-wide uppercase transition-all hover:scale-105 hover:shadow-lg hover:shadow-yellow-500/20"
          >
            Explore Skins
          </a>

          {/* Mobile Toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 text-gray-400 hover:text-yellow-400 transition-colors"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen ? (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-yellow-900/20">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`block px-4 py-3 rounded-lg text-base font-semibold tracking-wide uppercase transition-all ${
                  location.pathname === link.to
                    ? "text-yellow-400 bg-yellow-500/10"
                    : "text-gray-400 hover:text-yellow-400 hover:bg-white/5"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#featured-games"
              onClick={() => setMobileOpen(false)}
              className="block mt-3 px-4 py-3 rounded-lg gold-shimmer-bg text-black font-bold text-base tracking-wide uppercase text-center"
            >
              Explore Skins
            </a>
          </div>
        </div>
      ) : null}
    </nav>
  )
}
